import { GET_GLOBAL_DESTINATION_SERVICES_FAILURE } from 'modules/authorizations/store/types/globalTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { useDispatch } from 'react-redux';
import { getGlobalInfo } from 'modules/authorizations/authorizations.actions';

export const useFetchGlobalDestinationServiceDataHandler = showToast => {
  const dispatch = useDispatch();

  const fetchData = async (authId, globalId) => {
    try {
      const [globalInfoResp] = await Promise.all([dispatch(getGlobalInfo(authId))]);
      if (globalInfoResp.type === GET_GLOBAL_DESTINATION_SERVICES_FAILURE) {
        showToast('Failed fetching global destination services, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
      }
      return true;
    } catch (error) {
      showToast('Failed fetching global destination service data, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
  };

  return { fetchData };
};
